import { createAsyncThunk } from '@reduxjs/toolkit';
// eslint-disable-next-line no-restricted-imports
import { ApiFactory, ApiResponse } from 'shared/api';
import BaseError from 'utils/base-error';
import { z } from 'zod';

/**
 * Инстанс апишки
 */
const apiInstance = ApiFactory.getInstance();

/**
 * Схема для парсинга респонса
 */
export const GetCateringEventsByFormatSlugApiResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
            description: z.any(),
            images: z.array(
                z.object({
                    url: z.string(),
                }),
            ).optional().nullable(),
            format: z.object({
                name: z.string(),
            }).optional().nullable(),
        }),
    ),
});

type GetCateringEventsByFormatSlugActionResponse
    = ApiResponse<z.infer<typeof GetCateringEventsByFormatSlugApiResponseSchema>>
    | BaseError;

type GetCateringEventsByFormatSlugActionRequest = {
    formatSlug: string,
}

export const getCateringEventsByFormatSlug = createAsyncThunk<
    GetCateringEventsByFormatSlugActionResponse,
    GetCateringEventsByFormatSlugActionRequest
>(
    'CateringEventFormatActionsGetCateringEventsByFormatSlug',
    async ({
        formatSlug,
    }) => apiInstance.get(
        '/catering-events',
        {
            'filters[format][slug][$eq]': formatSlug,
            'populate[images][fields]': 'url',
            'populate[format][fields]': '*',
        },
        GetCateringEventsByFormatSlugApiResponseSchema,
    ),
);
